import { render, staticRenderFns } from "./config023Page.vue?vue&type=template&id=14808b6e&"
import script from "./config023Page.vue?vue&type=script&lang=js&"
export * from "./config023Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports